/**
 * Returns false.
 *
 * @returns {boolean} false.
 * @example
 * stubFalse() // Returns false
 */
export function stubFalse(): false;

/**
 * Returns false.
 *
 * @returns {boolean} false.
 * @example
 * stubFalse() // Returns false
 */
export function stubFalse(): false;

export function stubFalse(): false {
  return false;
}
